import React, { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const CreateAgent = lazy(() => import('../../container/users/CreateAgent'));
const UsersTable = lazy(() => import('../../container/users/UsersTable'));
const ManageAgent = lazy(() => import('../../container/users/ManageAgent'));
const CompanyDetails = lazy(() => import('../../container/users/overview/CompanyDetails'));
const AgentTable = lazy(() => import('../../container/users/overview/AgentTable'));

function AuthRoutes() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/agent/create`} component={CreateAgent} />
      <Route path={`${path}/company/new`} component={ManageAgent} />
      <Route path={`${path}/company/manage`} component={UsersTable} />
      <Route path={`${path}/agent/manage`} component={CompanyDetails} />
      <Route path={`${path}/agent/list`} component={AgentTable} />
    </Switch>
  );
}

export default AuthRoutes;
